/** Build-time configuration (Vite env). Copy `.env.example` to `.env.local`. Never put secrets here: everything in VITE_* ships to the browser. */
export type DataMode = 'mock' | 'api';

const mode = (import.meta.env.VITE_DATA_MODE || 'mock').toLowerCase();

export const env = {
  /** `mock` (default): fictional demo data in the browser. `api`: the backend at VITE_API_BASE_URL. */
  dataMode: (mode === 'api' ? 'api' : 'mock') as DataMode,
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, ''),
  /** `true` when the backend implements POST /analytics/management (otherwise the browser computes the figures). */
  serverAnalytics: String(import.meta.env.VITE_API_SERVER_ANALYTICS || '').toLowerCase() === 'true',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
};
